export function isRenderEngine(renderEngine) {
  return !Boolean(renderEngine.options);
}
export function isRenderEngineWithOptions(renderEngine) {
  return Boolean(renderEngine.options);
}